import React from 'react';
import {cn} from '@/utils';

export const Tag = ({
  isHot = false,
  children,
}: {
  isHot?: boolean;
  children?: React.ReactNode;
}) => {
  return (
    <div
      className={cn(
        'w-[1.875rem] h-[.875rem] rounded-full flex justify-center items-center text-[.5rem] bg-[#FF4D4F] text-white',
        isHot ? 'animate-hot' : '',
      )}>
      {children}
    </div>
  );
};
